var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlossary = function SvgGlossary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M1 6.428h38v40.715H6.429A5.429 5.429 0 0 1 1 41.712V6.429Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M1 6.429A5.429 5.429 0 0 1 6.429 1H39v10.857H6.429A5.429 5.429 0 0 1 1 6.43Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.429 24.429V10.857h8.143V24.43L28.5 20.357 24.43 24.43Z"
  })));
};
export default SvgGlossary;